import { useEffect } from "react";
import { TableOfContentItem } from "./type";

export function useAdjustHashPosition(tableOfContent: TableOfContentItem[], body: string) {
  useEffect(() => {
    tableOfContent.forEach((el) => {
      const heading = document.getElementById(el.id);

      if (!heading?.tagName.toLowerCase().match(/^h\d$/)) return;
      heading.style.position = "relative";
      const innerDiv = document.createElement("div");
      innerDiv.id = heading.id;
      innerDiv.style.position = "absolute";
      innerDiv.style.top = "-57px";

      if (heading.parentNode) {
        heading.appendChild(innerDiv);
        heading.id = "";
      }
    });
  }, [tableOfContent, body]);
}
